import * as React from "react";
export var Select1 = function (_a) {
    var _b = _a.options, options = _b === void 0 ? {} : _b, _c = _a.selected, selected = _c === void 0 ? 0 : _c, onChange = _a.onChange, _d = _a.title, title = _d === void 0 ? "" : _d, _e = _a.className, className = _e === void 0 ? "" : _e;
    return (React.createElement("div", { className: className + " select_div" },
        React.createElement("label", null, title),
        React.createElement("select", { className: "select1", onChange: onChange }, Object.keys(options).map(function (key, i) {
            return (React.createElement("option", { value: options[key], key: i, selected: options[key] == selected ? true : false }, key));
        }))));
};
export var SelectType2 = function (_a) {
    var _b = _a.options, options = _b === void 0 ? {} : _b, _c = _a.selected, selected = _c === void 0 ? 0 : _c, onChange = _a.onChange, _d = _a.title, title = _d === void 0 ? "" : _d, _e = _a.className, className = _e === void 0 ? "" : _e;
    return (React.createElement("div", { className: className + " selectType2_div" },
        React.createElement("label", null,
            title,
            " "),
        React.createElement("select", { className: "selectType2", onChange: onChange }, Object.keys(options).map(function (key, i) {
            return (React.createElement("option", { value: options[key], key: i, selected: options[key] == selected ? true : false }, key));
        }))));
};
